module.exports = __webpack_public_path__ + "static/img/58-1.1de1f1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/58-1.jpg
// module id = xynp
// module chunks = 0